import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/GENERAL/general";
import TODIS_FORM_DESC from "./form/GENERAL/description";
import TODIS_FORM_TENCOMPLIANCE from "./form/GENERAL/tencompliance";
import TODIS_FORM_ELEGPROJECT from "./form/GENERAL/elegibilityproject";
import TODIS_FORM_INDICATORS from "./form/GENERAL/indicators";
import TODIS_FORM_PERFOMANCE_INDICADOR from "./form/GENERAL/perfomanceindicador";
import TODIS_FORM_MARKET from "./form/LRAILS/market";
import TODIS_FORM_STATUS from "./form/LRAILS/status";
import { TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_LIVE_FUND from "./form/LRAILS/lFundingsources";
import TODIS_TECH_DOCU from "./form/LRAILS/lTechnicalDocumentation";
import TODIS_TIMELINE from "./form/GENERAL/lTimeline";
import TODIS_FORM_OTHER_RWP from "./form/LRAILS/other";
import { loadModules } from 'esri-loader';


const TODIS_LRAIL_FORM = ({ errors, touched, status, setFieldValue, values }) => {

    const [statusTabDisabled, setStatusTabDisabled] = useState(true)
    useEffect(() => {
        try {
            const [Query, query] = loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/25";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `live_rw_proj_id=${values.liveRwProjId}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            const results = query.executeQueryJSON(queryUrl, queryObject);

            if (results.features.length > 0) {
                setStatusTabDisabled(false);
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }

    })
    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const descriptionTooltip = (
        <Tooltip id="description-tooltip">
            Project description
        </Tooltip>
    )

    const statusTooltip = (
        <Tooltip id="status-tooltip">
            Project implementation status
        </Tooltip>
    )

    const tentIndicatorsTooltip = (
        <Tooltip id="tent-indicators-tooltip">
            The TEN-T indicators the project will be addressing
        </Tooltip>
    )

    const tentComplianceTooltip = (
        <Tooltip id="tent-compliance-tooltip">
            Current compliance of the railway section the project is related to
        </Tooltip>
    )

    const perfIndicatorsTooltip = (
        <Tooltip id="perfIndicators-tooltip">
            Project's compliance indicators
        </Tooltip >
    )

    const fundSourcesTooltip = (
        <Tooltip id="fundSources-tooltip">
            Project's funding sources
        </Tooltip>
    )

    const techDocuTooltip = (
        <Tooltip id="techDocu-tooltip">
            Project's technical documentation
        </Tooltip>
    )

    const otherTootltip = (
        <Tooltip id="other-tooltip">
            Other parameters related data
        </Tooltip>
    );

    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title={
                <OverlayTrigger placement="top" overlay={generalTooltip}>
                    <div>General</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} TypeForm="" TetCategory="tentTCategory" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lDescription" title={
                <OverlayTrigger placement="top" overlay={descriptionTooltip}>
                    <div>Description</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_DESC errors={errors} touched={touched} disabled={status} TypeForm="railwaysLivePmDescDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="railwaysLivePmDescDTO.remarks" label="Remarks" name="railwaysLivePmDescDTO.remarks" disabled={status} />
                            {errors.railwaysLivePmDescDTO && errors.railwaysLivePmDescDTO.remarks && touched.railwaysLivePmDescDTO && touched.railwaysLivePmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.railwaysLivePmDescDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lStatus" title={
                <OverlayTrigger placement="top" overlay={statusTooltip}>
                    <div>Status</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_STATUS errors={errors} touched={touched} disabled={status} TypeForm="railwaysLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lFund" title={
                <OverlayTrigger placement="top" overlay={fundSourcesTooltip}>
                    <div>Funding sources</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_LIVE_FUND errors={errors} touched={touched} disabled={status} TypeForm="railwaysLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTechDocu" title={
                <OverlayTrigger placement="top" overlay={techDocuTooltip}>
                    <div>Technical documentation</div>
                </OverlayTrigger>
            }>
                <TODIS_TECH_DOCU errors={errors} touched={touched} disabled={status} TypeForm="railwaysLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="lTimeline" title="Timeline">
                <TODIS_TIMELINE errors={errors} touched={touched} disabled={status} TypeForm="railwaysLivePmStatusDTO" setFieldValue={setFieldValue} values={values} />
            </Tab>

            <Tab eventKey="lElegibilityProject" title={
                <OverlayTrigger placement="top" overlay={tentIndicatorsTooltip}>
                    <div>Targeted TEN-T indicators</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="railwaysLivePmEligiTentDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="railwaysLivePmEligiTentDTO.remarks" label="Remarks" name="railwaysLivePmEligiTentDTO.remarks" disabled={status} />
                            {errors.railwaysLivePmEligiTentDTO && errors.railwaysLivePmEligiTentDTO.remarks && touched.railwaysLivePmEligiTentDTO && touched.railwaysLivePmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.railwaysLivePmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="lTenCompliance" title={
                <OverlayTrigger placement="bottom" overlay={tentComplianceTooltip}>
                    <div>TEN-T compliance of the related Railway</div>
                </OverlayTrigger>
            }>                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="railwaysLivePmTentcompDTO" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="railwaysLivePmTentcompDTO.remarks" label="Remarks" name="railwaysLivePmTentcompDTO.remarks" disabled={status} />
                            {errors.railwaysLivePmTentcompDTO && errors.railwaysLivePmTentcompDTO.remarks && touched.railwaysLivePmTentcompDTO && touched.railwaysLivePmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.railwaysLivePmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {/* <Tab eventKey="perfomanceindicador" title="Performance Indicators">
            <Container>
                <Row>
                    <TODIS_FORM_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="railwaysLivePmPiDTO" Name1="forecastTrainTraffic" Name2="actualTrainTraffic" Label1="Train traffic - forecasted" Label2="Train traffic - actual"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="railwaysLivePmPiDTO.remarks" label="Remarks" name="railwaysLivePmPiDTO.remarks" disabled={status}/>
                            {errors.railwaysLivePmPiDTO && errors.railwaysLivePmPiDTO.remarks && touched.railwaysLivePmPiDTO && touched.railwaysLivePmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20}/></span>Error: {errors.railwaysLivePmPiDTO.remarks}</div>) : null}
                        </Col>
                </Row>
            </Container>
        </Tab> */}
            <Tab eventKey="lIndicators" title={
                <OverlayTrigger placement="bottom" overlay={perfIndicatorsTooltip}>
                    <div>Performance indicators</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="railwaysLivePmIndicatorsDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="railwaysLivePmIndicatorsDTO.remarks" label="Remarks" name="railwaysLivePmIndicatorsDTO.remarks" disabled={status} />
                            {errors.railwaysLivePmIndicatorsDTO && errors.railwaysLivePmIndicatorsDTO.remarks && touched.railwaysLivePmIndicatorsDTO && touched.railwaysLivePmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.railwaysLivePmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Other" title={
                    <OverlayTrigger placement="bottom" overlay={otherTootltip}>
                        <div>Others</div>
                    </OverlayTrigger>
                }>
                    <Container>
                        <Row>
                            <TODIS_FORM_OTHER_RWP errors={errors} touched={touched} disabled={status} TypeForm="railwaysLiveOtherDTO" values={values} />
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}

export default TODIS_LRAIL_FORM;